var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { css, styled } from "../utils";
var StyledStatusTag = styled.div(function (_a) {
    var status = _a.status, _b = _a.theme, colors = _b.colors, font = _b.font, onClick = _a.onClick;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    background: ", "2d;\n    border-radius: 5px;\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    letter-spacing: 1px;\n    padding-left: 8px;\n    padding-right: 8px;\n    height: 25px;\n    line-height: 27px;\n    white-space: nowrap;\n    cursor: ", ";\n    text-transform: uppercase;\n  "], ["\n    display: inline-block;\n    background: ", "2d;\n    border-radius: 5px;\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    letter-spacing: 1px;\n    padding-left: 8px;\n    padding-right: 8px;\n    height: 25px;\n    line-height: 27px;\n    white-space: nowrap;\n    cursor: ", ";\n    text-transform: uppercase;\n  "])), colors.statusTag[status || 'completed'], colors.statusTag[status || 'completed'], font.weight.semiBold, font.size.tiny, onClick && 'pointer');
});
var StatusTag = function (props) { return (React.createElement(StyledStatusTag, __assign({ "data-component": "StatusTag" }, props))); };
export default StatusTag;
var templateObject_1;
//# sourceMappingURL=StatusTag.js.map